// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /* *{
    overflow-y: hidden;
    overflow-x: hidden;
}  */
.cardimage{
    width: 170px !important;
    vertical-align: middle;
}
.form-card{
    display: block;
    border-radius: 0;
    background: #f1f1f3;
    width: 100%;
    padding: .375rem .75rem;
    font-size: 1rem;
}
.form-card {
   border: 1px solid #ced4da; 
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    outline: none;
  }
  .form-card:focus {
    border-color: #82bcfa; 
    /* box-shadow: 0 0 0 0.2rem rgba(240, 240, 240, 0.25);  */
 }  
  .login-card{
    box-shadow: var(--bs-box-shadow);
  }
  .login-button{
    background-color:#028d43 !important;
    
  }
  .above-center {
    margin-top: -60px; 
  }
  .edit-profile{
    padding: 10px 30px;
  }
  .edit-profile span{
    font-size: 16px;
    color: #565b56dd;
  }
  .rounded-profile{
    width: 180px;
    height: 180px;
    overflow: hidden;
    border-width: 4px !important;
    border-color: #009345!important;
  }
  @media screen and (min-width: 320px) and (max-width:575px){
    /* .login{
      padding: 0px 43px 0px 0px;
    } */
    /* .login-card{
      width: 155%;
      height: 100%;
    } */
    .cardimage{
      padding-bottom: 14px !important;
    }
    /* .login-cardw{
      width: 100%;
      padding: 0px;
    } */
  }
  @media screen and  (min-width:576px) and ( max-width:768px){
    .login-card{
      width: 135%;
      height: 100%;
  }
  .cardimage{
    padding-bottom: 20px !important;
  }
  .login-column{
    width: 0%;
  }
}
@media screen and  (min-width:769px) and ( max-width:991px){
  .login-card{
    width: 120%;
    height: 100%;
}
.cardimage{
  padding-bottom: 20px !important;
}
.login-column{
  width: 0%;
}
}`, "",{"version":3,"sources":["webpack://./src/Components/login/Login.css"],"names":[],"mappings":"EAAE;;;IAGE;AACJ;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,eAAe;AACnB;AACA;GACG,yBAAyB;IACxB,wEAAwE;IACxE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,yDAAyD;CAC5D;EACC;IACE,gCAAgC;EAClC;EACA;IACE,mCAAmC;;EAErC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE;;OAEG;IACH;;;OAGG;IACH;MACE,+BAA+B;IACjC;IACA;;;OAGG;EACL;EACA;IACE;MACE,WAAW;MACX,YAAY;EAChB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;AAChB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,SAAS;AACX;AACA","sourcesContent":["  /* *{\n    overflow-y: hidden;\n    overflow-x: hidden;\n}  */\n.cardimage{\n    width: 170px !important;\n    vertical-align: middle;\n}\n.form-card{\n    display: block;\n    border-radius: 0;\n    background: #f1f1f3;\n    width: 100%;\n    padding: .375rem .75rem;\n    font-size: 1rem;\n}\n.form-card {\n   border: 1px solid #ced4da; \n    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n    outline: none;\n  }\n  .form-card:focus {\n    border-color: #82bcfa; \n    /* box-shadow: 0 0 0 0.2rem rgba(240, 240, 240, 0.25);  */\n }  \n  .login-card{\n    box-shadow: var(--bs-box-shadow);\n  }\n  .login-button{\n    background-color:#028d43 !important;\n    \n  }\n  .above-center {\n    margin-top: -60px; \n  }\n  .edit-profile{\n    padding: 10px 30px;\n  }\n  .edit-profile span{\n    font-size: 16px;\n    color: #565b56dd;\n  }\n  .rounded-profile{\n    width: 180px;\n    height: 180px;\n    overflow: hidden;\n    border-width: 4px !important;\n    border-color: #009345!important;\n  }\n  @media screen and (min-width: 320px) and (max-width:575px){\n    /* .login{\n      padding: 0px 43px 0px 0px;\n    } */\n    /* .login-card{\n      width: 155%;\n      height: 100%;\n    } */\n    .cardimage{\n      padding-bottom: 14px !important;\n    }\n    /* .login-cardw{\n      width: 100%;\n      padding: 0px;\n    } */\n  }\n  @media screen and  (min-width:576px) and ( max-width:768px){\n    .login-card{\n      width: 135%;\n      height: 100%;\n  }\n  .cardimage{\n    padding-bottom: 20px !important;\n  }\n  .login-column{\n    width: 0%;\n  }\n}\n@media screen and  (min-width:769px) and ( max-width:991px){\n  .login-card{\n    width: 120%;\n    height: 100%;\n}\n.cardimage{\n  padding-bottom: 20px !important;\n}\n.login-column{\n  width: 0%;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
